<template>
  <div>
    <left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin>
    <v-main>
      <div class="col-md-12 ml-sm-auto col-lg-12 px-4">
        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
        <v-row>
          <v-col cols="12">
            <v-sheet tile height="54" class="d-flex">
              <v-select
                v-model="Department"
                :items="DepartmentItem"
                dense
                outlined
                hide-details
                label="แผนก"
                class="ma-2"
              ></v-select>
              <!-- วัน -->
              <v-select
                v-model="day"
                :items="dayName"
                dense
                outlined
                hide-details
                label="วัน"
                class="ma-2"
              ></v-select>
              <!-- เดือน -->
              <v-select
                v-model="month"
                :items="monthNameTH"
                dense
                outlined
                hide-details
                label="เดือน"
                class="ma-2"
              ></v-select>
              <!-- ปี -->
              <v-select
                v-model="year"
                :items="yearsNumber"
                dense
                outlined
                hide-details
                label="ปี"
                class="ma-2"
              ></v-select>
              <!-- ค้นหา -->
              <v-icon
                color="#871B12"
                size="30"
                @click="search()"
                >mdi-calendar-search</v-icon
              >
              <v-icon color="#871B12" size="30" @click="clear()"
                >mdi-refresh</v-icon
              >
            </v-sheet>
          </v-col>
        </v-row>

        <v-row v-if="disableExport">
          <v-col cols="6">
            <v-btn
              :loading="loading3"
              :disabled="loading3"
              color="blue-grey"
              class="ma-2 white--text"
              @click="(loader = 'loading3'), exportEmpInfo()"
            >
              Download
              <v-icon right dark> mdi-cloud-download </v-icon>
            </v-btn>
            <v-btn
              :loading="loading3"
              :disabled="loading3"
              color="blue-grey"
              class="ma-2 white--text"
              @click="(loader = 'loading3'), clear()"
            >
              Reload
              <v-icon right dark> mdi-backup-restore </v-icon>
            </v-btn>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="searchAll2"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row v-if="disableExport">
          <!-- data table -->
          <v-col cols="12">
            <v-row cols="12">
              <v-col cols="12">
                <v-card elevation="7" v-if="dataReady">
                  <v-card-title> รายชื่อพนักงานทำแบบประเมินแล้ว </v-card-title>
                  <v-card-text>
                    <v-data-table
                      id="header-blue"
                      :headers="columns"
                      :items="dataItemComplate"
                      :search="searchAll2"
                      :items-per-page="10"
                    >
                      <template v-slot:[`item.CREATE_DATE`]="{ item }">
                        {{ format_date(item.CREATE_DATE) }}
                      </template>
                      <template v-slot:[`item.empImageUrl`]="{ item }">
                        <v-avatar size="72">
                          <img
                            v-if="item.empImageUrl"
                            alt="Avatar"
                            :src="item.empImageUrl"
                          />
                        </v-avatar>
                      </template>
                      <template v-slot:[`item.color`]="{ item }">
                        <v-chip
                          v-if="item.color === 'สีเขียว'"
                          class="ma-2"
                          color="green"
                          text-color="white"
                        >
                          {{ item.color }}
                        </v-chip>
                        <v-chip
                          v-if="item.color === 'สีเหลือง'"
                          class="ma-2"
                          color="yellow"
                          text-color="black"
                        >
                          {{ item.color }}
                        </v-chip>
                        <v-chip
                          v-if="item.color === 'สีส้ม'"
                          class="ma-2"
                          color="orange"
                          text-color="black"
                        >
                          {{ item.color }}
                        </v-chip>
                        <v-chip
                          v-if="item.color === 'สีแดง'"
                          class="ma-2"
                          color="red"
                          text-color="white"
                        >
                          {{ item.color }}
                        </v-chip>
                        <v-chip class="ma-2" v-if="!item.color">
                          ไม่พบข้อมูล
                        </v-chip>
                      </template>
                      <template v-slot:[`item.detail`]="{ item }">
                        <v-chip
                          v-if="item.detail === 'สาย'"
                          class="ma-2"
                          color="pink"
                          label
                          text-color="white"
                        >
                          {{ item.detail }}
                        </v-chip>
                        <v-chip
                          v-if="item.detail === 'ปกติ'"
                          class="ma-2"
                          color="primary"
                          label
                        >
                          {{ item.detail }}
                        </v-chip>
                        <v-chip
                          class="ma-2"
                          v-if="item.detail == 'ไม่พบข้อมูล'"
                        >
                          ไม่พบข้อมูล
                        </v-chip>
                      </template>
                      <template v-slot:[`item.LAST_DATE`]="{ item }">
                        {{ format_date(item.LAST_DATE) }}
                      </template>
                      <template v-slot:[`item.action`]="{ item }">
                        <v-btn
                          color="success"
                          fab
                          small
                          @click.stop="(dialog = true), getByEmp(item)"
                        >
                          <v-icon dark> mdi-map-marker </v-icon>
                        </v-btn>
                      </template>
                    </v-data-table>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12">
                <v-card elevation="7" v-if="dataReady">
                  <v-card-title>
                    รายชื่อพนักงานที่ยังไม่ทำแบบประเมิน
                  </v-card-title>
                  <v-card-text>
                    <v-data-table
                      id="header-purple"
                      :headers="columnsUnRisk"
                      :items="dataItemCantRisk"
                      :search="searchAll2"
                      :items-per-page="10"
                    >
                      <template v-slot:[`item.CREATE_DATE`]="{ item }">
                        {{ format_date(item.CREATE_DATE) }}
                      </template>
                      <template v-slot:[`item.empImageUrl`]="{ item }">
                        <v-avatar size="72">
                          <img
                            v-if="item.empImageUrl"
                            alt="Avatar"
                            :src="item.empImageUrl"
                          />
                        </v-avatar>
                      </template>
                      <template v-slot:[`item.color`]="{ item }">
                        <v-chip
                          v-if="item.color === 'สีเขียว'"
                          class="ma-2"
                          color="green"
                          text-color="white"
                        >
                          {{ item.color }}
                        </v-chip>
                        <v-chip
                          v-if="item.color === 'สีเหลือง'"
                          class="ma-2"
                          color="yellow"
                          text-color="black"
                        >
                          {{ item.color }}
                        </v-chip>
                        <v-chip
                          v-if="item.color === 'สีส้ม'"
                          class="ma-2"
                          color="orange"
                          text-color="black"
                        >
                          {{ item.color }}
                        </v-chip>
                        <v-chip
                          v-if="item.color === 'สีแดง'"
                          class="ma-2"
                          color="red"
                          text-color="white"
                        >
                          {{ item.color }}
                        </v-chip>
                        <v-chip class="ma-2" v-if="!item.color">
                          ไม่พบข้อมูล
                        </v-chip>
                      </template>
                      <template v-slot:[`item.detail`]="{ item }">
                        <v-chip
                          v-if="item.detail === 'สาย'"
                          class="ma-2"
                          color="pink"
                          label
                          text-color="white"
                        >
                          {{ item.detail }}
                        </v-chip>
                        <v-chip
                          v-if="item.detail === 'ปกติ'"
                          class="ma-2"
                          color="primary"
                          label
                        >
                          {{ item.detail }}
                        </v-chip>
                        <v-chip
                          class="ma-2"
                          v-if="item.detail == 'ไม่พบข้อมูล'"
                        >
                          ไม่พบข้อมูล
                        </v-chip>
                      </template>
                      <template v-slot:[`item.LAST_DATE`]="{ item }">
                        {{ format_date(item.LAST_DATE) }}
                      </template>
                      <template v-slot:[`item.action`]="{ item }">
                        <v-btn
                          color="success"
                          fab
                          small
                          @click.stop="(dialog = true), getByEmp(item)"
                        >
                          <v-icon dark> mdi-map-marker </v-icon>
                        </v-btn>
                      </template>
                    </v-data-table>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
            <v-row cols="12">
              <v-col cols="12">
                <v-card elevation="7" v-if="dataReady">
                  <v-card-title> สีแดง </v-card-title>
                  <v-card-text>
                    <v-data-table
                      id="header-red"
                      :headers="columnsRisk"
                      :items="dataItemRed"
                      :search="searchAll2"
                      :items-per-page="10"
                    >
                      <template v-slot:[`item.CREATE_DATE`]="{ item }">
                        {{ format_date(item.CREATE_DATE) }}
                      </template>
                      <template v-slot:[`item.empImageUrl`]="{ item }">
                        <v-avatar size="72">
                          <img
                            v-if="item.empImageUrl"
                            alt="Avatar"
                            :src="item.empImageUrl"
                          />
                        </v-avatar>
                      </template>
                      <template v-slot:[`item.formSaveRisk21`]="{ item }">
                        <v-chip-group
                            active-class="primary--text"
                            column
                          >
                            <v-chip
                            >
                              {{ item.formSaveRisk21 }}
                            </v-chip>
                          </v-chip-group>
                      </template>
                      <template v-slot:[`item.color`]="{ item }">
                        <v-chip
                          v-if="item.color === 'สีเขียว'"
                          class="ma-2"
                          color="green"
                          text-color="white"
                        >
                          {{ item.color }}
                        </v-chip>
                        <v-chip
                          v-if="item.color === 'สีเหลือง'"
                          class="ma-2"
                          color="yellow"
                          text-color="black"
                        >
                          {{ item.color }}
                        </v-chip>
                        <v-chip
                          v-if="item.color === 'สีส้ม'"
                          class="ma-2"
                          color="orange"
                          text-color="black"
                        >
                          {{ item.color }}
                        </v-chip>
                        <v-chip
                          v-if="item.color === 'สีแดง'"
                          class="ma-2"
                          color="red"
                          text-color="white"
                        >
                          {{ item.color }}
                        </v-chip>
                        <v-chip class="ma-2" v-if="!item.color">
                          ไม่พบข้อมูล
                        </v-chip>
                      </template>
                      <template v-slot:[`item.action`]="{ item }">
                        <v-btn
                          color="success"
                          fab
                          small
                          @click.stop="(dialog = true), getByEmp(item)"
                        >
                          <v-icon dark> mdi-map-marker </v-icon>
                        </v-btn>
                      </template>
                    </v-data-table>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12">
                <v-card elevation="7" v-if="dataReady">
                  <v-card-title> สีส้ม </v-card-title>
                  <v-card-text>
                    <v-data-table
                      id="header-orange"
                      :headers="columnsRisk"
                      :items="dataItemOrange"
                      :search="searchAll2"
                      :items-per-page="10"
                    >
                      <template v-slot:[`item.CREATE_DATE`]="{ item }">
                        {{ format_date(item.CREATE_DATE) }}
                      </template>
                      <template v-slot:[`item.formSaveRisk21`]="{ item }">

                        <v-chip-group
                            active-class="primary--text"
                            column
                          >
                            <v-chip
                            >
                              {{ item.formSaveRisk21 }}
                            </v-chip>
                          </v-chip-group>
                      </template>
                      <template v-slot:[`item.empImageUrl`]="{ item }">
                        <v-avatar size="72">
                          <img
                            v-if="item.empImageUrl"
                            alt="Avatar"
                            :src="item.empImageUrl"
                          />
                        </v-avatar>
                      </template>
                      <template v-slot:[`item.color`]="{ item }">
                        <v-chip
                          v-if="item.color === 'สีเขียว'"
                          class="ma-2"
                          color="green"
                          text-color="white"
                        >
                          {{ item.color }}
                        </v-chip>
                        <v-chip
                          v-if="item.color === 'สีเหลือง'"
                          class="ma-2"
                          color="yellow"
                          text-color="black"
                        >
                          {{ item.color }}
                        </v-chip>
                        <v-chip
                          v-if="item.color === 'สีส้ม'"
                          class="ma-2"
                          color="orange"
                          text-color="black"
                        >
                          {{ item.color }}
                        </v-chip>
                        <v-chip
                          v-if="item.color === 'สีแดง'"
                          class="ma-2"
                          color="red"
                          text-color="white"
                        >
                          {{ item.color }}
                        </v-chip>
                        <v-chip class="ma-2" v-if="!item.color">
                          ไม่พบข้อมูล
                        </v-chip>
                      </template>
                      <template v-slot:[`item.action`]="{ item }">
                        <v-btn
                          color="success"
                          fab
                          small
                          @click.stop="(dialog = true), getByEmp(item)"
                        >
                          <v-icon dark> mdi-map-marker </v-icon>
                        </v-btn>
                      </template>
                    </v-data-table>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
            <v-row cols="12">
              <v-col cols="12">
                <v-card elevation="7" v-if="dataReady">
                  <v-card-title> สีเหลือง </v-card-title>
                  <v-card-text>
                    <v-data-table
                      id="header-yellow"
                      :headers="columnsRisk"
                      :items="dataItemYellow"
                      :search="searchAll2"
                      :items-per-page="10"
                    >
                      <template v-slot:[`item.CREATE_DATE`]="{ item }">
                        {{ format_date(item.CREATE_DATE) }}
                      </template>
                      <template v-slot:[`item.formSaveRisk21`]="{ item }">
                        <v-chip
                            dark
                          >
                            {{ item.formSaveRisk21 }}
                          </v-chip>
                      </template>

                      <template v-slot:[`item.empImageUrl`]="{ item }">
                        <v-avatar size="72">
                          <img
                            v-if="item.empImageUrl"
                            alt="Avatar"
                            :src="item.empImageUrl"
                          />
                        </v-avatar>
                      </template>
                      <template v-slot:[`item.color`]="{ item }">
                        <v-chip
                          v-if="item.color === 'สีเขียว'"
                          class="ma-2"
                          color="green"
                          text-color="white"
                        >
                          {{ item.color }}
                        </v-chip>
                        <v-chip
                          v-if="item.color === 'สีเหลือง'"
                          class="ma-2"
                          color="yellow"
                          text-color="black"
                        >
                          {{ item.color }}
                        </v-chip>
                        <v-chip
                          v-if="item.color === 'สีส้ม'"
                          class="ma-2"
                          color="orange"
                          text-color="black"
                        >
                          {{ item.color }}
                        </v-chip>
                        <v-chip
                          v-if="item.color === 'สีแดง'"
                          class="ma-2"
                          color="red"
                          text-color="white"
                        >
                          {{ item.color }}
                        </v-chip>
                        <v-chip class="ma-2" v-if="!item.color">
                          ไม่พบข้อมูล
                        </v-chip>
                      </template>
                      <template v-slot:[`item.action`]="{ item }">
                        <v-btn
                          color="success"
                          fab
                          small
                          @click.stop="(dialog = true), getByEmp(item)"
                        >
                          <v-icon dark> mdi-map-marker </v-icon>
                        </v-btn>
                      </template>
                    </v-data-table>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12">
                <v-card elevation="7" v-if="dataReady">
                  <v-card-title> สีเขียว </v-card-title>
                  <v-card-text>
                    <v-data-table
                      id="header-green"
                      :headers="columns"
                      :items="dataItemGreen"
                      :search="searchAll2"
                      :items-per-page="10"
                    >
                      <template v-slot:[`item.CREATE_DATE`]="{ item }">
                        {{ format_date(item.CREATE_DATE) }}
                      </template>
                      <template v-slot:[`item.empImageUrl`]="{ item }">
                        <v-avatar size="72">
                          <img
                            v-if="item.empImageUrl"
                            alt="Avatar"
                            :src="item.empImageUrl"
                          />
                        </v-avatar>
                      </template>
                      <template v-slot:[`item.color`]="{ item }">
                        <v-chip
                          v-if="item.color === 'สีเขียว'"
                          class="ma-2"
                          color="green"
                          text-color="white"
                        >
                          {{ item.color }}
                        </v-chip>
                        <v-chip
                          v-if="item.color === 'สีเหลือง'"
                          class="ma-2"
                          color="yellow"
                          text-color="black"
                        >
                          {{ item.color }}
                        </v-chip>
                        <v-chip
                          v-if="item.color === 'สีส้ม'"
                          class="ma-2"
                          color="orange"
                          text-color="black"
                        >
                          {{ item.color }}
                        </v-chip>
                        <v-chip
                          v-if="item.color === 'สีแดง'"
                          class="ma-2"
                          color="red"
                          text-color="white"
                        >
                          {{ item.color }}
                        </v-chip>
                        <v-chip class="ma-2" v-if="!item.color">
                          ไม่พบข้อมูล
                        </v-chip>
                      </template>
                      <template v-slot:[`item.action`]="{ item }">
                        <v-btn
                          color="success"
                          fab
                          small
                          @click.stop="(dialog = true), getByEmp(item)"
                        >
                          <v-icon dark> mdi-map-marker </v-icon>
                        </v-btn>
                      </template>
                    </v-data-table>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>

            <div v-if="!dataReady" class="text-center">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </div>
          </v-col>
          <!-- end data table -->
          <v-dialog
            v-model="dialog"
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
          >
            <v-card>
              <v-toolbar dark color="primary">
                <v-btn icon dark @click="dialog = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>รายละเอียด</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>

              <v-col cols="12">
                <v-expansion-panels v-model="panel" multiple>
                  <v-expansion-panel>
                    <v-expansion-panel-header disable-icon-rotate>
                      <template v-slot:actions>
                        <v-icon color="#871B12">
                          mdi-account-circle-outline
                        </v-icon>
                      </template>
                      {{ dataByEmp.empFull_NameTH }}
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row>
                        <v-col cols="4">
                          <v-card elevation="2">
                            <center>
                              <v-avatar
                                class="profile"
                                style="margin-top: 10px"
                                color="grey"
                                size="164"
                                rounded
                              >
                                <v-img :src="dataByEmp.empImageUrl"></v-img>
                              </v-avatar>
                            </center>
                            <v-col>
                              <v-card-text
                                ><v-icon color="#871B12">mdi-account</v-icon
                                ><strong>ชื่อ-นามสกุล: </strong
                                >{{ dataByEmp.empFull_NameTH }}
                              </v-card-text>
                              <v-card-text>
                                <v-icon color="#871B12">mdi-account</v-icon>
                                <strong>หน่วยงาน: </strong
                                >{{ dataByEmp.masDepartmentName }}
                              </v-card-text>
                              <v-card-text>
                                <v-icon color="#871B12">mdi-account</v-icon>
                                <strong>สาขา : </strong
                                >{{ dataByEmp.masBranchName }}
                              </v-card-text>
                              <v-card-text
                                ><v-icon color="#871B12">mdi-account-box</v-icon
                                ><strong>รหัสพนักงาน : </strong
                                >{{ dataByEmp.empCode }}</v-card-text
                              >
                              <v-card-text
                                ><v-icon color="#871B12">
                                  mdi-cellphone-basic </v-icon
                                ><strong>เบอร์โทรศัพท์ : </strong
                                >{{ dataByEmp.empTel }}</v-card-text
                              >
                              <v-card-text
                                ><v-icon color="#871B12"> mdi-email </v-icon
                                ><strong>อีเมล์ : </strong
                                >{{ dataByEmp.empEmail }}
                              </v-card-text>
                            </v-col>
                          </v-card>
                        </v-col>

                        <v-col cols="8">
                          <v-card elevation="2">
                            <v-simple-table fixed-header height="530px">
                              <template v-slot:default>
                                <thead>
                                  <tr>
                                    <th
                                      class="text-center"
                                      style="background-color: #1b437c"
                                    >
                                      วัน/เดือน/ปี
                                    </th>
                                    <th
                                      class="text-center"
                                      style="background-color: #1b437c"
                                    >
                                      เวลา
                                    </th>
                                    <th
                                      class="text-center"
                                      style="background-color: #1b437c"
                                    >
                                      สี
                                    </th>
                                    <th
                                      class="text-center"
                                      style="background-color: #1b437c"
                                    >
                                      อาการ
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr
                                    v-for="(
                                      items2, index2
                                    ) in dataByEmp.shifttem"
                                    :key="index2"
                                  >
                                    <td class="text-center">
                                      {{ items2.shiftDay }}/{{
                                        items2.shiftMonth
                                      }}/{{ items2.shiftYear }}
                                    </td>
                                    <td
                                      v-if="items2.time_as"
                                      class="text-center"
                                    >
                                      {{ items2.time_as }}
                                    </td>
                                    <td
                                      v-if="!items2.time_as"
                                      class="text-center"
                                    >
                                      <v-chip class="ma-2">
                                        ไม่พบข้อมูล
                                      </v-chip>
                                    </td>
                                    <td class="text-center">
                                      <v-chip
                                        v-if="items2.color === 'สีเขียว'"
                                        class="ma-2"
                                        color="green"
                                        text-color="white"
                                      >
                                        {{ items2.color }}
                                      </v-chip>
                                      <v-chip
                                        v-if="items2.color === 'สีเหลือง'"
                                        class="ma-2"
                                        color="yellow"
                                        text-color="black"
                                      >
                                        {{ items2.color }}
                                      </v-chip>
                                      <v-chip
                                        v-if="items2.color === 'สีแดง'"
                                        class="ma-2"
                                        color="red"
                                        text-color="black"
                                      >
                                        {{ items2.color }}
                                      </v-chip>
                                      <v-chip
                                        v-if="items2.color === 'สีส้ม'"
                                        class="ma-2"
                                        color="orange"
                                        text-color="black"
                                      >
                                        {{ items2.color }}
                                      </v-chip>
                                      <v-chip class="ma-2" v-if="!items2.color">
                                        ไม่พบข้อมูล
                                      </v-chip>
                                    </td>
                                    <td class="text-center">
                                                  <v-chip-group
                                        active-class="primary--text"
                                        column
                                      >
                                        <v-chip
                                        v-if="items2.formSaveRisk21"
                                        >
                                          {{ items2.formSaveRisk21 }}
                                        </v-chip>
                                        <v-chip class="ma-2" v-if="!items2.formSaveRisk21">
                                        ไม่พบข้อมูล
                                      </v-chip>
                                      </v-chip-group>
                                    </td>
                                  </tr>
                                </tbody>
                              </template>
                            </v-simple-table>
                          </v-card>
                        </v-col>
                        <v-col cols="12">
                          <v-col>
                            <!-- {{dataByEmp.shifttem}}
                        <label v-for="items2 in dataByEmp.shifttem" :key="items2" >
                            {{items2.position}}
                            </label> -->
                            <!-- {{dataByEmp.shifttem}} -->
                            <GmapMap
                              :center="center"
                              map-type-id="terrain"
                              ref="mapRef"
                              :zoom="zoom"
                              style="width: 100%; height: 600px"
                              :options="{ disableDefaultUI: true }"
                            >
                              <GmapMarker :position="center" />
                               <GmapMarker
                                v-for="(m, indexMap1) in dataByEmp.shifttemMapCheckIn"
                                :key="indexMap1"
                                :position="m.positionIn"
                                :clickable="true"
                                :icon="m.iconIn"
                                @click="openWindows(m)"
                              />
                              <GmapMarker
                                v-for="(
                                  m2, indexMap2
                                ) in dataByEmp.shifttemMapCheckout"
                                :key="indexMap2 + 'M2'"
                                :position="m2.positionOut"
                                :clickable="true"
                                :icon="m2.iconOut"
                                @click="openWindows2(m2)"
                              />
                              <gmap-info-window
                                  @closeclick="window_open=false"
                                  :opened="window_open"
                                  :position="infowindow_position"
                                  :options="{
                                    pixelOffset: {
                                      width: 0,
                                      height: -35
                                    }
                                  }"
                              >
                                  {{infowindow_detail}}
                              </gmap-info-window>
                            </GmapMap>
                          </v-col>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>
            </v-card>
          </v-dialog>
        </v-row>
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import adminLeftMenu from '../../Sidebar.vue' // เมนู
import XLSX from 'xlsx' // import xlsx
import moment from 'moment' // แปลง date
import dayName from '../../../assets/master/Date/day.json'
import monthNameTH from '../../../assets/master/Date/monthNameTH.json'
import yearsNumber from '../../../assets/master/Date/yearsNumber.json'
import { gmapApi } from 'vue2-google-maps'

export default {
  components: {
    'left-menu-admin': adminLeftMenu,
    XLSX,
    moment,
    gmapApi
  },
  watch: {
    loader () {
      const l = this.loader
      this[l] = !this[l]

      setTimeout(() => (this[l] = false), 3000)

      this.loader = null
    }
  },
  data () {
    return {
      PK: '',
      center: {},
      session: this.$session.getAll(),
      // Menu Config
      breadcrumbs: [
        {
          text: 'Home',
          disabled: false,
          href: '/Core/Home'
        },
        {
          text: 'รายงาน Covid-19 สาขา',
          disabled: false,
          href: '/CheckINOUT/ReportCovidHelp'
        }
      ],
      dialog: false,
      dataReady: true,
      dateTime: '', // Generate DateTime
      searchAll2: '',
      loader: null,
      loading3: false,
      date: new Date().toISOString().substr(0, 10),
      // Data Table Config
      columns: [
        { text: 'ชื่อ - นามสกุล', value: 'empFull_NameTH', align: 'center' },
        { text: 'แผนก', value: 'masDepartmentName', align: 'center' },
        { text: 'สาขา', value: 'masBranchName', align: 'center' },
        { text: 'บริษัท', value: 'masCompanyName', align: 'center' },
        { text: 'Check IN', value: 'checkInStartStamp', align: 'center' },
        { text: 'Check Out', value: 'checkInEndStamp', align: 'center' },
        { text: 'ประเมิน', value: 'color', align: 'center' },
        { text: 'เวลาประเมิน', value: 'time_as', align: 'center' },
        { text: 'Action', value: 'action', sortable: false, align: 'center' }
      ],
      columnsUnRisk: [
        { text: 'ชื่อ - นามสกุล', value: 'empFull_NameTH', align: 'center' },
        { text: 'แผนก', value: 'masDepartmentName', align: 'center' },
        { text: 'สาขา', value: 'masBranchName', align: 'center' },
        { text: 'บริษัท', value: 'masCompanyName', align: 'center' },
        { text: 'Check IN', value: 'checkInStartStamp', align: 'center' },
        { text: 'Check Out', value: 'checkInEndStamp', align: 'center' },
        { text: 'Action', value: 'action', sortable: false, align: 'center' }
      ],
      columnsRisk: [
        { text: 'ชื่อ - นามสกุล', value: 'empFull_NameTH', align: 'center' },
        { text: 'แผนก', value: 'masDepartmentName', align: 'center' },
        { text: 'สาขา', value: 'masBranchName', align: 'center' },
        { text: 'บริษัท', value: 'masCompanyName', align: 'center' },
        { text: 'Check IN', value: 'checkInStartStamp', align: 'center' },
        { text: 'Check Out', value: 'checkInEndStamp', align: 'center' },
        { text: 'อาการ', value: 'formSaveRisk21', align: 'center' },
        { text: 'Action', value: 'action', sortable: false, align: 'center' }
      ],
      columnsRiskReport: [
        { text: 'แผนก', value: 'masDepartmentName', align: 'center' },
        { text: 'สาขา', value: 'masBranchName', align: 'center' },
        { text: 'บริษัท', value: 'masCompanyName', align: 'center' },
        { text: 'สีเขียว', value: 'green', align: 'center' },
        { text: 'สีเหลือง', value: 'yellow', align: 'center' },
        { text: 'สีส้ม', value: 'orange', align: 'center' },
        { text: 'สีแดง', value: 'red', align: 'center' },
        { text: 'รวม', value: 'count_all', sortable: true, align: 'center' }
      ],
      colorItemlist: ['สีเขียว', 'สีเหลือง', 'สีส้ม', 'สีแดง'],
      dataItem: [],
      dataExportItem: [],
      dataExportItem1: [],
      dataExportItem2: [],
      dataExportItem3: [],
      dataExportItem4: [],
      dataByEmp: [],
      BranchItem: [], // สาขา
      DepartmentItem: [], // แผนก
      CompanyItem: [], // บริษัท
      Company: '', // บริษัท
      Branch: '', // บริษัท
      Department: '', // บริษัท
      disableBranch: true,
      disableDeparment: true,
      disableSearch: false,
      disableExport: false,
      year: '',
      month: '',
      day: '',
      disableYear: true,
      disableMonth: true,
      dayName: dayName,
      monthNameTH: monthNameTH,
      yearsNumber: yearsNumber,
      panel: [0, 1],
      coutLate: 0,
      coutOnTime: 0,
      coutAbsent: 0,
      coutRiskDone: 0,
      coutRiskEmpty: 0,
      coutGreen: 0,
      coutYellow: 0,
      coutOrange: 0,
      coutRed: 0,
      dataItemGreen: [],
      dataItemOrange: [],
      dataItemYellow: [],
      dataItemRed: [],
      dataItemComplate: [],
      dataItemCantRisk: [],
      reportItemDay: [],
      reportItemDepartment: [],
      zoom: 14,
      window_open: false,
      infowindow_position: {lat: 10, lng: 10.0},
      infowindow_detail: ''
    }
  },
  async mounted () {
    await this.getGetToken()
    await this.geolocate()
    this.dataReady = false

    this.month = this.getMonthTh()
    let date = new Date()
    this.year = moment().format('YYYY')
    this.day = date.getDate()

    await this.getDataDepartment()

    await this.clear()
  },
  methods: {
    geolocate () {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const center = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          }
          this.dataReady = true
          this.center = center
        },
        (error) => {
          console.log('error map :', error.message)
          alert('กรุณาเปิด location ของท่าน')
        }
      )
    },
    async getDataToday () {
      this.dataReady = false

      this.coutGreen = 0
      this.coutYellow = 0
      this.coutOrange = 0
      this.coutRed = 0

      var Department = (this.Department === '' ? '' : '&masDepartmentName=' + this.Department)

      this.colorItemlist.forEach(async (element) => {
        //  console.log(element)
        if (element) {
          await axios
            .get(
              // eslint-disable-next-line quotes
              this.DNS_IP +
                '/shift_import/get?shiftDay=' +
                this.day +
                '&shiftMonth=' +
                this.getMonthThToINT(this.month) +
                '&shiftYear=' +
                this.year +
                '&color=' +
                element +
                '&masBranchName=' +
                this.$session.getAll().data.masBranchName +
                Department,
              {
                headers: {
                  'Application-Key': this.$session.getAll().ApplicationKey
                }
              }
            )
            .then(async (response) => {
              this.dataReady = true
              this.disableExport = true // Show Export
              // 'สีเขียว', 'สีเหลือง', 'สีส้ม', 'สีแดง'
              this.dataExportItem = response.data

              if (element === 'สีเขียว') {
                this.dataItemGreen = response.data
                this.coutGreen = response.data.length
              }
              if (element === 'สีเหลือง') {
                this.dataItemYellow = response.data
                //  console.log('dataItemYellow : ', this.dataItemYellow)
                // JSON.parse(this.dataItemYellow.formSaveRisk21)
                // this.dataItemYellow.

                this.coutYellow = response.data.length
              }
              if (element === 'สีส้ม') {
                this.dataItemOrange = response.data
                this.coutOrange = response.data.length
                //  console.log('dataItemOrange : ', this.dataItemOrange)
              }
              if (element === 'สีแดง') {
                this.dataItemRed = response.data
                this.coutRed = response.data.length
              }

              // this.getData()
            })
            // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              //  console.log(error)
              this.dataReady = true
            })
        }
      })
    },
    async getDataTodayComplete () {
      this.dataReady = false
      this.dataItemComplate = []
      var Department = (this.Department === '' ? '' : '&masDepartmentName=' + this.Department)
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/shift_import/getIsNotNullRisk?shiftDay=' +
            this.day +
            '&shiftMonth=' +
            this.getMonthThToINT(this.month) +
            '&isnull=true&shiftYear=' +
            this.year +
             '&masBranchName=' +
              this.$session.getAll().data.masBranchName +
                Department,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          this.dataReady = true
          this.disableExport = true // Show Export
          this.dataItemComplate = response.data
          // this.getData()
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          //  console.log(error)
          this.dataReady = true
        })
    },
    async getDataTodayCant () {
      this.dataReady = false
      this.dataItemCantRisk = []
      var Department = (this.Department === '' ? '' : '&masDepartmentName=' + this.Department)
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/shift_import/getIsNullRisk?shiftDay=' +
            this.day +
            '&shiftMonth=' +
            this.getMonthThToINT(this.month) +
            '&shiftYear=' +
            this.year +
            '&isnull=true' +
             '&masBranchName=' +
              this.$session.getAll().data.masBranchName +
                Department,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          this.dataReady = true
          this.disableExport = true // Show Export
          this.dataItemCantRisk = response.data
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          //  console.log(error)
          this.dataReady = true
        })
    },
    //
    async clear () {
      this.Company = ''
      this.Branch = ''
      this.Department = ''
      await this.getDataToday()
      await this.getDataTodayComplete()
      await this.getDataTodayCant()
    },
    async search () {
      await this.getDataToday()
      await this.getDataTodayComplete()
      await this.getDataTodayCant()
      // await this.charJsSearch()
      // await this.charDepartmentSearch()
    },
    async getByEmp (dt) {
      dt.empImageUrl = this.DNS_IP + '/' + dt.empImageUrl
      this.dataReady = false
      this.dataByEmp = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/shift_import/get?empCode=' +
            dt.empCode +
            '&shiftMonth=' +
            this.getMonthThToINT(this.month) +
            '&shiftYear=' +
            this.year
        )
        .then(async (response) => {
          this.dataReady = true
          dt.shifttem = response.data
          dt.shifttemMapCheckIn = response.data
          this.mapGetDataCheckRisk(dt.shifttemMapCheckIn)
          dt.shifttem.forEach((shifttem) => {
            if (shifttem.checkInStartStamp) {
              var date =
                shifttem.checkInYear +
                '-' +
                shifttem.checkInMonth +
                '-' +
                shifttem.checkInDay
              var startStamp = new Date(
                date + ' ' + shifttem.checkInStartStamp
              )
              var masShiftTypeStartTime = new Date(
                date + ' ' + shifttem.masShiftTypeStartTime
              )

              if (startStamp > masShiftTypeStartTime) {
                shifttem.colorin = 'red'
              } else {
                shifttem.colorin = 'green'
              }

              if (shifttem.checkInEndStamp) {
                shifttem.checkInEndStamp = shifttem.checkInEndStamp
                shifttem.colorout = 'green'
              } else {
                shifttem.checkInEndStamp = 'ไม่พบข้อมูล'
                shifttem.colorout = '-'
              }
            } else {
              shifttem.checkInStartStamp = 'ไม่พบข้อมูล'
              shifttem.checkInEndStamp = 'ไม่พบข้อมูล'
              shifttem.colorin = '-'
              shifttem.colorout = '-'
            }
          })
          dt.shifttem = dt.shifttem
            .slice()
            .sort((a, b) => a.shiftDay - b.shiftDay)
          this.dataByEmp = dt
          //  console.log('dt : ', this.dataByEmp)
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = true
        })
    },
    mapGetDataCheckRisk (dt) {
      dt.forEach((shifttem) => {
        var position = {
          lat: null,
          lng: null
        }
        if (shifttem.color) {
          position = {
            lat: Number(shifttem.Lat),
            lng: Number(shifttem.Long)
          }
          //  console.log(shifttem.color)
          if (shifttem.color === 'สีส้ม') {
            shifttem.iconIn = require('@/assets/virus.png')
          } else {
            shifttem.iconIn =
            'https://firebasestorage.googleapis.com/v0/b/betask-crm.appspot.com/o/marker%2Fin.png?alt=media'
          }
          // this.imageUrlBack = require('@/assets/Icon/Back.jpg')
          shifttem.positionIn = position
          this.center = position
        } else {
          shifttem.positionIn = position
        }
      })
    },
    openWindows (m) {
      console.log('m', m)
      this.zoom = 19
      this.center = m.positionIn
      this.window_open = true
      this.infowindow_position = m.positionIn

      this.infowindow_detail = 'วันที่ ' + m.checkInDay + '/' + m.checkInMonth + '/' + m.checkInYear + '\nเข้างานเมื่อ ' + m.checkInStartStamp
      // this.panToMarker(this.center)
    },
    openWindows2 (m) {
      console.log('m2', m)
      this.zoom = 19
      this.center = m.positionOut
      this.infowindow_position = m.positionOut
      this.window_open = true
      this.infowindow_detail = 'วันที่ ' + m.checkInDay + '/' + m.checkInMonth + '/' + m.checkInYear + '\nออกงานเมื่อ ' + m.checkInEndStamp
      // this.panToMarker(this.center)
    },
    exportEmpInfo () {
      var greenItem = []
      this.dataItemGreen.forEach((element) => {
        let s = {
          'รหัสพนักงาน': element.empCode,
          'ชื่อพนักงาน': element.empFull_NameTH,
          'แผนก': element.masDepartmentName,
          'สาขา': element.masBranchName,
          'บริษัท': element.masCompanyName,
          'เบอร์โทร': element.empTel,
          'อีเมล': element.empEmail,
          'ปี': element.checkInYear,
          'เดือน': element.checkInMonth,
          'วัน': element.checkInDay,
          'กะ': element.masShiftTypeName,
          'เวลาเข้างาน': element.checkInStartStamp,
          'เวลาออกงาน': element.checkInEndStamp,
          'ระดับสีประเมินความเสี่ยง': element.color,
          'ข้อ1': element.formSaveRisk1,
          'ข้อ2': element.formSaveRisk21,
          'ข้อ3': element.formSaveRisk3,
          'ข้อ4': element.formSaveRisk4,
          'ข้อ5': element.formSaveRisk5,
          'ข้อ6': element.formSaveRisk6,
          'ข้อ7': element.formSaveRisk7
        }
        greenItem.push(s)
      })
      var yellowItem = []
      this.dataItemYellow.forEach((element) => {
        let s = {
          'รหัสพนักงาน': element.empCode,
          'ชื่อพนักงาน': element.empFull_NameTH,
          'แผนก': element.masDepartmentName,
          'สาขา': element.masBranchName,
          'บริษัท': element.masCompanyName,
          'เบอร์โทร': element.empTel,
          'อีเมล': element.empEmail,
          'ปี': element.checkInYear,
          'เดือน': element.checkInMonth,
          'วัน': element.checkInDay,
          'กะ': element.masShiftTypeName,
          'เวลาเข้างาน': element.checkInStartStamp,
          'เวลาออกงาน': element.checkInEndStamp,
          'ระดับสีประเมินความเสี่ยง': element.color,
          'ข้อ1': element.formSaveRisk1,
          'ข้อ2': element.formSaveRisk21,
          'ข้อ3': element.formSaveRisk3,
          'ข้อ4': element.formSaveRisk4,
          'ข้อ5': element.formSaveRisk5,
          'ข้อ6': element.formSaveRisk6,
          'ข้อ7': element.formSaveRisk7
        }
        yellowItem.push(s)
      })
      var orangeItem = []
      this.dataItemOrange.forEach((element) => {
        let s = {
          'รหัสพนักงาน': element.empCode,
          'ชื่อพนักงาน': element.empFull_NameTH,
          'แผนก': element.masDepartmentName,
          'สาขา': element.masBranchName,
          'บริษัท': element.masCompanyName,
          'เบอร์โทร': element.empTel,
          'อีเมล': element.empEmail,
          'ปี': element.checkInYear,
          'เดือน': element.checkInMonth,
          'วัน': element.checkInDay,
          'กะ': element.masShiftTypeName,
          'เวลาเข้างาน': element.checkInStartStamp,
          'เวลาออกงาน': element.checkInEndStamp,
          'ระดับสีประเมินความเสี่ยง': element.color,
          'ข้อ1': element.formSaveRisk1,
          'ข้อ2': element.formSaveRisk21,
          'ข้อ3': element.formSaveRisk3,
          'ข้อ4': element.formSaveRisk4,
          'ข้อ5': element.formSaveRisk5,
          'ข้อ6': element.formSaveRisk6,
          'ข้อ7': element.formSaveRisk7
        }
        orangeItem.push(s)
      })
      var redItem = []
      this.dataItemRed.forEach((element) => {
        let s = {
          'รหัสพนักงาน': element.empCode,
          'ชื่อพนักงาน': element.empFull_NameTH,
          'แผนก': element.masDepartmentName,
          'สาขา': element.masBranchName,
          'บริษัท': element.masCompanyName,
          'เบอร์โทร': element.empTel,
          'อีเมล': element.empEmail,
          'ปี': element.checkInYear,
          'เดือน': element.checkInMonth,
          'วัน': element.checkInDay,
          'กะ': element.masShiftTypeName,
          'เวลาเข้างาน': element.checkInStartStamp,
          'เวลาออกงาน': element.checkInEndStamp,
          'ระดับสีประเมินความเสี่ยง': element.color,
          'ข้อ1': element.formSaveRisk1,
          'ข้อ2': element.formSaveRisk21,
          'ข้อ3': element.formSaveRisk3,
          'ข้อ4': element.formSaveRisk4,
          'ข้อ5': element.formSaveRisk5,
          'ข้อ6': element.formSaveRisk6,
          'ข้อ7': element.formSaveRisk7
        }
        redItem.push(s)
      })
      var riskItem = []
      this.dataItemComplate.forEach((element) => {
        let s = {
          'รหัสพนักงาน': element.empCode,
          'ชื่อพนักงาน': element.empFull_NameTH,
          'แผนก': element.masDepartmentName,
          'สาขา': element.masBranchName,
          'บริษัท': element.masCompanyName,
          'เบอร์โทร': element.empTel,
          'อีเมล': element.empEmail,
          'ปี': element.checkInYear,
          'เดือน': element.checkInMonth,
          'วัน': element.checkInDay,
          'กะ': element.masShiftTypeName,
          'เวลาเข้างาน': element.checkInStartStamp,
          'เวลาออกงาน': element.checkInEndStamp,
          'ระดับสีประเมินความเสี่ยง': element.color
        }
        riskItem.push(s)
      })
      var cantRiskItem = []
      this.dataItemCantRisk.forEach((element) => {
        let s = {
          'รหัสพนักงาน': element.empCode,
          'ชื่อพนักงาน': element.empFull_NameTH,
          'แผนก': element.masDepartmentName,
          'สาขา': element.masBranchName,
          'บริษัท': element.masCompanyName,
          'เบอร์โทร': element.empTel,
          'อีเมล': element.empEmail,
          'ปี': element.checkInYear,
          'เดือน': element.checkInMonth,
          'วัน': element.checkInDay,
          'กะ': element.masShiftTypeName,
          'เวลาเข้างาน': element.checkInStartStamp,
          'เวลาออกงาน': element.checkInEndStamp,
          'ระดับสีประเมินความเสี่ยง': element.color
        }
        cantRiskItem.push(s)
      })
      var green = XLSX.utils.json_to_sheet(greenItem)
      var yellow = XLSX.utils.json_to_sheet(yellowItem)
      var orange = XLSX.utils.json_to_sheet(orangeItem)
      var red = XLSX.utils.json_to_sheet(redItem)
      var risk = XLSX.utils.json_to_sheet(riskItem)
      var cantRisk = XLSX.utils.json_to_sheet(cantRiskItem)
      var wb = XLSX.utils.book_new() // make Workbook of Excel
      XLSX.utils.book_append_sheet(wb, risk, 'ทำแบบประเมินเรียบร้อย') // sheetAName is name of Worksheet
      XLSX.utils.book_append_sheet(wb, cantRisk, 'ยังไม่ทำแบบประเมิน') // sheetAName is name of Worksheet
      XLSX.utils.book_append_sheet(wb, green, 'สีเขียว') // sheetAName is name of Worksheet
      XLSX.utils.book_append_sheet(wb, yellow, 'สีเหลือง') // sheetAName is name of Worksheet
      XLSX.utils.book_append_sheet(wb, orange, 'สีส้ม') // sheetAName is name of Worksheet
      XLSX.utils.book_append_sheet(wb, red, 'สีแดง') // sheetAName is name of Worksheet
      XLSX.writeFile(wb, 'Covid-Report(' + this.day + ' ' + this.month + ' ' + this.year + ').xls') // name of the file is 'book.xlsx'
    },
    // แผนก
    async getDataDepartment () {
      // this.disableDeparment = false
      // console.log('masBranchCode', masBranchCode)
      this.DepartmentItem = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/master_department/get?masBranchName=" +
            this.$session.getAll().data.masBranchName,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          this.disableDeparment = false
          this.disableYear = false
          this.disableMonth = false
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.text = d.masDepartmentName
            s.value = d.masDepartmentName
            d = s
            this.DepartmentItem.push(d)
          }
          // // console.log('getDataDepartment : ', this.DepartmentItem)
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.disableDeparment = true
          this.disableYear = true
          this.disableMonth = true
          // // console.log(error)
        })
    },
    departmentCheckSearch (departmentCheckSearch) {
      if (departmentCheckSearch) {
        this.disableSearch = true
      }
    }
  }
}
</script>
<style scope>
:root {
  --nav-text: #b61c1c;
  --table-head-bg: #b61c1c;
  --table-head-text: #000000;
  --table-body-row-even: #b1c9ea;
  --table-body-row-odd: #ffffff;
  --table-body-text: #1b437c;
}
#header-green {
  background-color: #00c853;
}
#header-yellow {
  background-color: #ffd600;
}
#header-orange {
  background-color: #ff9800;
}
#header-red {
  background-color: #d32f2f;
}
#header-purple {
  background-color: #e0e0e0;
}
#header-blue {
  background-color: #80d8ff;
}
/* .v-data-table-header {
  background-color: var(--table-head-bg) !important;
} */
.theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  color: var(--table-head-text) !important;
}
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  padding: 8px 5px 8px 15px !important;
}
.v-data-table > .v-data-table__wrapper > table > tbody > tr:nth-child(even) {
  background: var(--table-body-row-even);
}
.v-data-table > .v-data-table__wrapper > table > tbody > tr:nth-child(odd) {
  background: var(--table-body-row-odd);
}
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  color: var(--table-body-text) !important;
}
.theme--light.v-data-table .v-data-table-header th.sortable.active,
.theme--light.v-data-table
  .v-data-table-header
  th.sortable.active
  .v-data-table-header__icon,
.theme--light.v-data-table .v-data-table-header th.sortable:hover {
  color: var(--table-head-text) !important;
}
.theme--light.v-data-table
  .v-data-table-header
  th.sortable
  .v-data-table-header__icon {
  color: var(--table-head-text) !important;
}
.menu-head {
  color: var(--nav-text) !important;
  font-size: 35px !important;
}

canvas{

  height:500px !important;

}
</style>



// WEBPACK FOOTER //
// src/components/HRM/ReportCovid/ReportBranch.vue